// The app has exactly one scrolling surface per screen (ADR-067 Decision 3):
// `<main>` inside Layout. Nothing nested inside a page may open a scrollport
// of its own.
//
// Components that need to drive or observe the page scroll (chat-style
// "scroll to newest", "jump to latest" affordances) must therefore reach the
// element Layout owns rather than scrolling a container of their own. This
// module is the single place that knows how to find it, so the id lives in one
// file instead of being re-typed at every call site.

export const APP_SCROLL_ID = 'app-scroll'

export function getAppScrollElement(): HTMLElement | null {
  if (typeof document === 'undefined') return null
  return document.getElementById(APP_SCROLL_ID)
}

/**
 * Scrolls the page to its top — ADR-106 Q12(a)'s "tap the already-active
 * item": nothing else about the screen changes. The stop's own scroll
 * tracking (`useStopScroll`) records the new position like any other scroll.
 */
export function scrollAppToTop(): void {
  const el = getAppScrollElement()
  if (!el) return
  el.scrollTop = 0
  el.dispatchEvent(new Event('scroll'))
}
